import { useState } from "react";

const dealers = ["Teknoloji Dünyası", "Bilgisayar Plaza", "Ofis Market", "Ana Bayi", "Elektronik Merkezi"];

const allData = [
  { dealer: "Teknoloji Dünyası", invoiceCount: 12, totalQty: 45, totalAmount: 28500, avgAmount: 2375, lastSale: "2026-07-17" },
  { dealer: "Bilgisayar Plaza", invoiceCount: 8, totalQty: 32, totalAmount: 19600, avgAmount: 2450, lastSale: "2026-07-16" },
  { dealer: "Ofis Market", invoiceCount: 15, totalQty: 78, totalAmount: 12400, avgAmount: 827, lastSale: "2026-07-15" },
  { dealer: "Ana Bayi", invoiceCount: 22, totalQty: 112, totalAmount: 45600, avgAmount: 2073, lastSale: "2026-07-17" },
  { dealer: "Elektronik Merkezi", invoiceCount: 6, totalQty: 18, totalAmount: 9800, avgAmount: 1633, lastSale: "2026-07-14" },
];

export default function CustomerBasedSalesReport() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dealer, setDealer] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [search, setSearch] = useState("");

  const data = allData.filter((i) => {
    if (dealer && i.dealer !== dealer) return false;
    if (minAmount && i.totalAmount < Number(minAmount)) return false;
    if (search && !i.dealer.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-secondary-600 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">Cari Bazlı Satış Rapor Kriterleri</span>
          <button onClick={() => { setStartDate(""); setEndDate(""); setDealer(""); setMinAmount(""); setSearch(""); }} className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer">Temizle</button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="sm:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Tarih Aralığı</label>
            <div className="flex items-center gap-2">
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
              <span className="text-sm text-foreground-400">-</span>
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Cari Bayi</label>
            <select value={dealer} onChange={(e) => setDealer(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400 cursor-pointer">
              <option value="">Tümü</option>
              {dealers.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Min. Tutar</label>
            <input type="number" placeholder="0" value={minAmount} onChange={(e) => setMinAmount(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
          </div>
          <div className="sm:col-span-2 lg:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Bayi Ara</label>
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input type="text" placeholder="Ara..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full pl-9 pr-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground-950">Cari Bazlı Satışlar</h2>
        <span className="text-sm text-foreground-500">{data.length} cari</span>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Cari Bayi</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Fatura Adet</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Toplam Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Toplam Tutar</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Ort. Tutar</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Son Satış</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 font-medium text-foreground-900">{item.dealer}</td>
                <td className="px-4 py-3 text-center text-foreground-700">{item.invoiceCount}</td>
                <td className="px-4 py-3 text-center text-foreground-700">{item.totalQty}</td>
                <td className="px-4 py-3 text-right font-semibold text-foreground-900">${item.totalAmount.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right text-foreground-500">${item.avgAmount.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-foreground-500">{item.lastSale}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {data.map((item, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <div className="flex items-start justify-between">
              <p className="text-sm font-medium text-foreground-900">{item.dealer}</p>
              <p className="text-sm font-bold text-foreground-900">${item.totalAmount.toLocaleString("en-US")}</p>
            </div>
            <p className="text-xs text-foreground-400 mt-1">{item.invoiceCount} fatura · {item.totalQty} adet · Son: {item.lastSale}</p>
          </div>
        ))}
      </div>
    </div>
  );
}